import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { VisitService } from '../services/visit.service';
import { MessageService } from '../services/message.service';
import { Message } from '../common/message';
import { OrderPrintService } from '../service/order-print.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-order-print',
  templateUrl: './order-print.component.html',
  styleUrls: ['./order-print.component.scss']
})
export class OrderPrintComponent implements OnInit {

  resource: any;
  form: FormGroup;
  nextMaintenance: number;
  lastOrderHour: number;
  lastOrderDate:any;
  lastVisitHour: number;
  lastVisitDate: Date;
  lastEngineVisit: any;
  prevLastEngineVisit: any;
  lastEngineOrder: any;
  visitOrder: any;
  cssStyle: string = "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);@import url(https://fonts.googleapis.com/icon?family=Material+Icons);@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.8.2/css/all.min.css);@import url(https://fonts.googleapis.com/css?family=Cairo:400,600,700&display=swa);@import url(~@angular/material/prebuilt-themes/indigo-pink.css);body,html{height:100%;margin:0 auto;direction:rtl;font-family:Cairo,sans-serif}a{text-decoration:none}.container{width:95%;margin:0 auto;padding:1.3em;display:grid;grid-template-columns:30% auto}.container a{color:#fff}.logo{font-size:18px;font-family:Montserrat;background-color:#5b9ce2;width:42%;padding:22px;margin:-21px;margin-right:-33px;padding-right:48px}.confirm-dialog{width:400px;direction:rtl}.confirm-dialog h1{font-size:50px;text-align:center;color:orange;margin:0}.confirm-dialog h2{font-size:18px;text-align:center}.confirm-dialog div{width:100%;display:flex;align-items:center;padding-right:90px}h1{color:#007bff}h2{color:gray;font-size:14px;font-weight:700}section{width:100%;margin:0 auto;font-size:14px}section aside{float:right;width:16%;padding-right:15px;padding-top:15px;background-color:#f8f9fa;min-height:600px;font-family:Montserrat}section aside hr{border-top:1px solid #f5f5f5;margin:3px}section aside div{padding:5px;margin:5px;cursor:pointer}section aside div a{color:grey;text-decoration:none}section aside div a:hover{color:#000;text-underline-position:below}section aside h2{font-size:16px}section main{padding-right:10px;padding-left:10px;border-right:1px solid #dcdcdc;float:right;width:80%;min-height:600px}.btn{font-family:Cairo,sans-serif;border:none;margin:5px;text-transform:uppercase;border-radius:4px;padding:1em;cursor:pointer}.btn-lg{width:100px;font-size:12px}.btn-sm{background-color:#fff;width:40px;font-size:10px;color:gray}.btn-sm:hover{background-color:#dcdcdc}.btn-save{background:#007bff;color:#fff}.btn-cancel{background:red;color:#fff}.results{margin-top:50px}.results strong{display:block}.results span{margin-bottom:20px;display:block}table{margin-top:10px;width:100%;font-family:Cairo,sans-serif!important}table td,table th{border:1px solid #dcdcdc;padding:5px;text-align:center}th.mat-header-cell{text-align:center!important}.mat-elevation-z8{box-shadow:none!important}td.mat-cell:last-of-type,td.mat-footer-cell:last-of-type,th.mat-header-cell:last-of-type{padding-right:0!important}.add-button{margin-top:-45px;float:left;color:green;cursor:pointer;margin-left:20px}.selected{color:#007bff;font-weight:700}.selected:hover{color:#007bff}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;min-height:56px;padding:0 8px;flex-wrap:wrap-reverse;width:100%;direction:ltr}.mat-simple-snackbar{display:flex;justify-content:space-between;align-items:center;height:100%;line-height:20px;opacity:1;float:right}.mat-simple-snackbar{font-family:Cairo,sans-serif;font-size:14px;color:#f8f9fa}input[type=date],input[type=datetime-local],input[type=time]{text-align:right}td.mat-cell:first-of-type,td.mat-footer-cell:first-of-type,th.mat-header-cell:first-of-type{padding-left:24px;padding-right:20px}.visit-label{background-color:#d3d3d3;width:98%;color:bold;font-size:18px;margin-bottom:2px}label{float:right;padding:10px;width:300px}label input{width:200px}label select{width:230px}br,hr{clear:both}table{border-spacing:0}fieldset{border:solid 1px #d3d3d3;margin-bottom:20px}.order-hour{margin-top:10px;margin-right:500px;background-color:gray;padding:15px;color:#fff;font-size:20px}input[disabled]{background-color:#fff}"

  constructor(
    private service: VisitService,
    private router: Router,
    private msg: MessageService,
    private formBuilder: FormBuilder,
    private orderPrintService: OrderPrintService
  ) { }

  ngOnInit() {
    this.setMessageForm();
    //get resource data;
    this.resource = this.orderPrintService.getPrintResource();
    if (!this.resource)
      this.router.navigate(['/home']);
    else
      this.onEngineChange(this.resource.motorId);
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
      hoursread: ['', Validators.required],
      requestType: ['', Validators.required],
      orderNumber: ['', Validators.required],
      orderHour: ['', Validators.required],
      actions: ['', Validators.required],
      notes: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
      supervisor: ['', Validators.required],
      generatorNumber: ['', Validators.required],
      reviewed: ['', Validators.required],
      accountId: ['', Validators.required],
      reviewerId: ['', Validators.required],
      powertrainId: [{ value: '', disabled: true }, Validators.required],
      motorId: [{ value: '', disabled: true }, Validators.required],
      workshopId: [{ value: '', disabled: true }, Validators.required],
      actionStatus: ['', Validators.required],
      lastvisithour: ['', Validators.required],
      lastorderhour: ['', Validators.required],
      orderGeneratedDate: ['', Validators.required]
    });
  }

  onEngineChange(engine: string) {

    forkJoin(
      [
        this.service.getEngineLastOrderHour(engine),
        this.service.getEngineLastVisitHour(engine),
        this.service.getEngineLastOrderDetails(engine),
        this.service.getVisitOrder(this.resource.id)
      ])
      .subscribe((results: any) => {

        this.lastOrderHour = (results && results[0] && results[0][0] && results[0][0].orderHour) ? results[0][0].orderHour : 0;
        this.lastOrderDate = (results && results[0] && results[0][0] && results[0][0].orderHour) ? moment(results[0][0].date).format("YYYY/MM/DD") : "";
        this.lastVisitDate = (results && results[1] && results[1][0] && results[1][0].date) ? results[1][0].date : null;
        this.lastEngineOrder = (results && results[2] && results[2][0]) ? results[2][0] : null;
        this.lastEngineVisit = (results && results[1] && results[1][0]) ? results[1][0] : null;
        this.prevLastEngineVisit = (results && results[1] && results[1][1]) ? results[1][1] : null;
        this.visitOrder = (results && results[3] && results[3][0]) ? results[3][0] : null;

        this.lastVisitHour = (this.lastEngineVisit && this.lastEngineVisit.hoursread) ? this.lastEngineVisit.hoursread : this.resource.motor.hoursread;

      }, (err: any) => {
        this.msg.alert(Message.ERROR_IN_GET_LAST_ENGINE_HOURS);
      })
  }
}
